import { consoleLog } from "./helpers.jsx"

/**
 * Executes reCAPTCHA v3 for the given action and resolves to a token to send
 * along with the request (register, password_reset, ...), or null if the
 * token couldn't be obtained -- callers should still submit the request
 * without one rather than block the user, since the API's own verification
 * treats a missing token as "unverifiable, fall back to rate limiting"
 * rather than an outright reject (see chaperon-api's userHandler.js).
 *
 * grecaptcha is loaded globally via the script tag in index.html
 * (render=VITE_RECAPTCHA_SITE_KEY), not an npm package -- there's no
 * existing pattern in this codebase for a React wrapper around it, and v3
 * has no visible widget to mount, so a plain window.grecaptcha call is all
 * that's needed here.
 */
export function getRecaptchaToken(action) {
    const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY

    if (!siteKey || !window.grecaptcha) {
        consoleLog("reCAPTCHA not available (missing site key or script not loaded yet)")
        return Promise.resolve(null)
    }

    return new Promise((resolve) => {
        window.grecaptcha.ready(() => {
            window.grecaptcha
                .execute(siteKey, { action })
                .then((token) => resolve(token))
                .catch((error) => {
                    console.error("reCAPTCHA execution failed:", error)
                    resolve(null)
                })
        })
    })
}
